import {v4 as uuidv4} from "uuid";

export function GetNewGuid() {
    return uuidv4();
}